import {inject, Injectable} from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
    providedIn: 'root'
})
export class ContractIconService {
  private iconsStore:Set<string> = new Set([
  'archive-stack-fill',
  'add-circle-fill',
  'arrow-down-s-line', 
  'arrow-go-back-fill',
  'arrow-up-s-line', 
  'attachment-2',
  'bank-fill',
  'briefcase-4-fill',
  'checkbox-circle-fill',
  'checkbox-circle-line',
  'checkbox-fill', 
  'checkbox-multiple-fill',
  'check-double-fill',
  'check-fill',
  'chevron-down',
  'chevron-up',
  'close-circle-line',
  'close-fill',
  'close-line',
  'coins-fill',
  'delete-bin-5-fill', 
  'delete-bin-5-line',
  'edit-2-fill',
  'error-warning-line', 
  'file-2-fill',
  'file-check-line',
  'file-check-fill',
  'file-chart-2-fill',
  'file-list-2-line',
  'file-search-fill',
  'file-text-fill',
  'file-upload-fill',
  'flag-line',
  'file-edit-line',
  'home-4-fill',
  'information-line',
  'image-circle-ai-fill',
  'organization-chart',
  'pause-line',
  'presentation-fill',
  'refresh-line',
  'refresh-fill',
  'save-2-fill',
  'shield-star-fill',
  'task-fill',
  'time-line', 
  'timer-2-line',
  'timer-2-line',
  'user-add-fill',
  'user-received-2-fill',
  'user-shared-fill',
  'user-wallet',
  'wallet-2-fill'
])
  constructor () {
    const iconRegistry = inject(MatIconRegistry);
    const sanitizer = inject(DomSanitizer);
    this.iconsStore.forEach(icon=>{
      iconRegistry.addSvgIcon(icon, sanitizer.bypassSecurityTrustResourceUrl('../../../../assets/icons/'+icon+'.svg'));
    })
  }
}
